module.exports = __webpack_public_path__ + "img/alipay-charge.710bc444.svg";